import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Founding Offer is DISABLED (platform is payment-first, slab pricing).
// This legacy route now redirects to the live pricing page so no stale
// per-user / founding figures are ever shown.
export default function FoundingOfferPage() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/pricing', { replace: true }); }, [navigate]);
  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300" data-testid="founding-page-redirect">
      <p className="text-sm">Pricing पर ले जा रहे हैं…</p>
    </div>
  );
}
